import { z } from 'zod';

export const meshAnnotationSchema = z.object({
    id: z.string(),
    visited: z.boolean(),
    initColor: z.string(),
    visitedColor: z.string(),
    tooltip: z.string().nullable(),
    showTooltip: z.enum([ 'always', 'onHover', 'onClick' ]),
    dataPosition: z.object({
        x: z.number(),
        y: z.number(),
        z: z.number(),
    }),
    dataNormal: z.object({
        x: z.number(),
        y: z.number(),
        z: z.number(),
    }),
});


// Annotation types for 3D models
export type MeshAnnotation = z.infer<typeof meshAnnotationSchema>;

export const mediaMetaSchema = z.object({
    mesh: z.object({
        autoRotate: z.boolean().optional(),
        shadowIntensity: z.number().optional(),
        annotations: z.array(meshAnnotationSchema).optional(),
        selectedAnimation: z.string().nullable().optional(),
    }).optional(),
});

export type MediaMeta = z.infer<typeof mediaMetaSchema>;

export const instanceMediaMetaSchema = z.object({
    originalname: z.string().optional(),
    mimetype: z.string().optional(),
});

export type InstanceMediaMeta = z.infer<typeof instanceMediaMetaSchema>;
